var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_mdls _p2 _con",
      class: _vm._class,
      style: { transformOrigin: _vm.transformOrigin },
      attrs: { dir: _vm.direction }
    },
    [
      _c("div", { staticClass: "_mdlsa", style: _vm.origin }),
      _c(
        "div",
        {
          ref: "content",
          staticClass: "_mdlsdef _p2def",
          style: { width: _vm.width, height: _vm.height }
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }